import { IdentityDto } from '../shared';
import { EntityDto } from '../entity';

export class ClientDto {
  identity: IdentityDto;
  entity: EntityDto;
  type: string;
  region?: string;
  companyCode?: string;
  errors?: Array<any>;
  isBHNClient?: boolean;

  constructor(d?: ClientDto) {
    Object.assign(this, d);
  }
}
